export default __webpack_public_path__ + "static/media/crossDark.eedf6462.svg";